/* EYESHELLS desktop navigation controller, v1415.
   One delegated controller replaces per-item hover listeners and keeps ARIA,
   keyboard, pointer and Theme Editor states synchronized. */
(function (w, d) {
  'use strict';

  var mq = w.matchMedia ? w.matchMedia('(min-width:1200px)') : { matches:true, addEventListener:function(){}, removeEventListener:function(){} };
  var finePointerMq = w.matchMedia ? w.matchMedia('(hover:hover) and (pointer:fine)') : { matches:true };
  var root = null;
  var openItem = null;
  var enterTimer = 0;
  var leaveTimer = 0;
  var lastPointerType = '';

  function clearTimers() {
    if (enterTimer) w.clearTimeout(enterTimer);
    if (leaveTimer) w.clearTimeout(leaveTimer);
    enterTimer = 0;
    leaveTimer = 0;
  }

  function itemPanel(item) {
    if (!item) return null;
    return item.querySelector(':scope > .es-nav-panel');
  }

  function itemTrigger(item) {
    if (!item) return null;
    return item.querySelector(':scope > .nav-link[aria-haspopup="true"]');
  }

  function setFlyoutState(flyout, expanded) {
    if (!flyout) return;
    var trigger = flyout.querySelector(':scope > a[aria-haspopup="true"]');
    var panel = flyout.querySelector(':scope > .es-nav-submenu');
    flyout.classList.toggle('es-flyout-open', !!expanded);
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  function closeSiblingFlyouts(flyout) {
    var parent = flyout && flyout.parentElement;
    if (!parent) return;
    parent.querySelectorAll(':scope > .es-has-flyout.es-flyout-open').forEach(function (other) {
      if (other !== flyout) setFlyoutState(other, false);
    });
  }

  function setFlyouts(item, expanded) {
    if (!item) return;
    item.querySelectorAll('.es-has-flyout').forEach(function (flyout) {
      if (!expanded || !flyout.classList.contains('es-flyout-open')) setFlyoutState(flyout, false);
    });
  }

  function closeItem(item, restoreFocus) {
    if (!item) return;
    var trigger = itemTrigger(item);
    var panel = itemPanel(item);
    item.classList.remove('es-dropdown-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    setFlyouts(item, false);
    if (openItem === item) openItem = null;
    if (restoreFocus && trigger) {
      try { trigger.focus({ preventScroll:true }); } catch (_err) { try { trigger.focus(); } catch (_err2) {} }
    }
  }

  function closeAll(except, restoreFocus) {
    if (!root) return;
    root.querySelectorAll('.es-nav-item.es-dropdown-open').forEach(function (item) {
      if (item !== except) closeItem(item, restoreFocus && item === openItem);
    });
  }

  function open(item, focusFirst) {
    if (!mq.matches || !item) return;
    clearTimers();
    closeAll(item, false);
    var trigger = itemTrigger(item);
    var panel = itemPanel(item);
    item.classList.add('es-dropdown-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    openItem = item;
    if (focusFirst && panel) {
      var first = panel.querySelector('a[href],button:not([disabled])');
      if (first) {
        try { first.focus({ preventScroll:true }); } catch (_err) { first.focus(); }
      }
    }
  }

  function closestItem(target) {
    return target && target.closest ? target.closest('.header-v1-h1 .navbar-nav > .es-nav-item.es-has-dropdown') : null;
  }

  function onPointerOver(event) {
    if (!mq.matches) return;
    lastPointerType = event.pointerType || '';
    if (lastPointerType === 'touch') return;
    var item = closestItem(event.target);
    if (!item) return;
    var flyout = event.target.closest && event.target.closest('.es-has-flyout');
    if (flyout && item.contains(flyout)) {
      closeSiblingFlyouts(flyout);
      setFlyoutState(flyout, true);
    }
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;
    clearTimers();
    enterTimer = w.setTimeout(function () { open(item, false); }, 80);
  }

  function onPointerOut(event) {
    if (!mq.matches || lastPointerType === 'touch') return;
    var item = closestItem(event.target);
    if (!item) return;
    var flyout = event.target.closest && event.target.closest('.es-has-flyout');
    if (flyout && (!event.relatedTarget || !flyout.contains(event.relatedTarget))) {
      w.setTimeout(function () {
        if (!flyout.matches(':hover') && !flyout.contains(d.activeElement)) setFlyoutState(flyout, false);
      }, 80);
    }
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;
    clearTimers();
    leaveTimer = w.setTimeout(function () { closeItem(item, false); }, 140);
  }

  function onFocusIn(event) {
    if (!mq.matches) return;
    var item = closestItem(event.target);
    if (item) open(item, false);

    var flyout = event.target.closest && event.target.closest('.es-has-flyout');
    if (flyout && item) {
      closeSiblingFlyouts(flyout);
      setFlyoutState(flyout, true);
    }
  }

  function onFocusOut(event) {
    if (!mq.matches) return;
    var item = closestItem(event.target);
    if (!item) return;
    w.setTimeout(function () {
      if (!item.contains(d.activeElement)) closeItem(item, false);
    }, 0);
  }

  function onClick(event) {
    if (!mq.matches) return;
    var trigger = event.target.closest && event.target.closest('.header-v1-h1 .navbar-nav > .es-has-dropdown > .nav-link[aria-haspopup="true"]');
    if (trigger) {
      var item = trigger.closest('.es-has-dropdown');
      var isTouchLike = lastPointerType === 'touch' || !finePointerMq.matches;
      if (isTouchLike && !item.classList.contains('es-dropdown-open')) {
        event.preventDefault();
        open(item, false);
        return;
      }
    }

    var flyoutTrigger = event.target.closest && event.target.closest('.es-has-flyout > a[aria-haspopup="true"]');
    if (flyoutTrigger && (lastPointerType === 'touch' || !finePointerMq.matches)) {
      var flyout = flyoutTrigger.closest('.es-has-flyout');
      if (!flyout.classList.contains('es-flyout-open')) {
        event.preventDefault();
        closeSiblingFlyouts(flyout);
        setFlyoutState(flyout, true);
      }
    }
  }

  function onDocumentClick(event) {
    if (!root || root.contains(event.target)) return;
    closeAll(null, false);
  }

  function onKeydown(event) {
    if (!mq.matches || !root) return;
    var trigger = event.target.closest && event.target.closest('.es-has-dropdown > .nav-link[aria-haspopup="true"]');
    if (trigger && (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ')) {
      if (event.key !== 'Enter' || trigger.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        open(trigger.closest('.es-has-dropdown'), true);
      }
      return;
    }
    if (event.key === 'Escape') {
      if (openItem) {
        event.preventDefault();
        closeItem(openItem, true);
      }
      return;
    }
    if (event.key === 'Tab' && openItem) {
      w.setTimeout(function () {
        if (openItem && !openItem.contains(d.activeElement)) closeItem(openItem, false);
      }, 0);
    }
  }

  function onBreakpoint() {
    if (!mq.matches) closeAll(null, false);
  }

  function bind() {
    var next = d.querySelector('.header-v1-h1[data-es-layout-header="desktop"]');
    if (!next) return;
    if (root === next && root.getAttribute('data-es-dropdown-bound') === '1') return;
    unbind();
    root = next;
    root.setAttribute('data-es-dropdown-bound', '1');
    root.addEventListener('pointerover', onPointerOver);
    root.addEventListener('pointerout', onPointerOut);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
    d.addEventListener('click', onDocumentClick, true);
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
  }

  function unbind() {
    clearTimers();
    if (root) {
      root.removeEventListener('pointerover', onPointerOver);
      root.removeEventListener('pointerout', onPointerOut);
      root.removeEventListener('focusin', onFocusIn);
      root.removeEventListener('focusout', onFocusOut);
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeydown);
      root.removeAttribute('data-es-dropdown-bound');
    }
    d.removeEventListener('click', onDocumentClick, true);
    if (mq.removeEventListener) mq.removeEventListener('change', onBreakpoint);
    else if (mq.removeListener) mq.removeListener(onBreakpoint);
    root = null;
    openItem = null;
  }

  function ready() {
    bind();
    ['shopify:section:load','shopify:section:reorder'].forEach(function (name) {
      d.addEventListener(name, bind);
    });
    d.addEventListener('shopify:section:unload', function () { w.setTimeout(bind, 0); });
    w.addEventListener('pageshow', function () { closeAll(null, false); bind(); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
})(window, document);
